'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var JsBase64 = require('js-base64');

var out_of_memory =
/* tuple */
["Out_of_memory", 0];
var sys_error =
/* tuple */
["Sys_error", -1];
var failure =
/* tuple */
["Failure", -2];
var invalid_argument =
/* tuple */
["Invalid_argument", -3];
var end_of_file =
/* tuple */
["End_of_file", -4];
var division_by_zero =
/* tuple */
["Division_by_zero", -5];
var not_found =
/* tuple */
["Not_found", -6];
var match_failure =
/* tuple */
["Match_failure", -7];
var stack_overflow =
/* tuple */
["Stack_overflow", -8];
var sys_blocked_io =
/* tuple */
["Sys_blocked_io", -9];
var assert_failure =
/* tuple */
["Assert_failure", -10];
var undefined_recursive_module =
/* tuple */
["Undefined_recursive_module", -11];
out_of_memory.tag = 248;
sys_error.tag = 248;
failure.tag = 248;
invalid_argument.tag = 248;
end_of_file.tag = 248;
division_by_zero.tag = 248;
not_found.tag = 248;
match_failure.tag = 248;
stack_overflow.tag = 248;
sys_blocked_io.tag = 248;
assert_failure.tag = 248;
undefined_recursive_module.tag = 248;
/*  Not a pure module */

function caml_array_sub(x, offset, len) {
  var result = new Array(len);
  var j = 0;
  var i = offset;

  while (j < len) {
    result[j] = x[i];
    j = j + 1 | 0;
    i = i + 1 | 0;
  }

  return result;
}
/* No side effect */


function app(_f, _args) {
  while (true) {
    var args = _args;
    var f = _f;
    var arity = f.length;
    var arity$1 = arity === 0 ? 1 : arity;
    var len = args.length;
    var d = arity$1 - len | 0;

    if (d === 0) {
      return f.apply(null, args);
    } else if (d < 0) {
      _args = caml_array_sub(args, arity$1, -d | 0);
      _f = f.apply(null, caml_array_sub(args, 0, arity$1));
      continue;
    } else {
      return function (f, args) {
        return function (x) {
          return app(f, args.concat(
          /* array */
          [x]));
        };
      }(f, args);
    }
  }
}

function curry_1(o, a0, arity) {
  if (arity > 7 || arity < 0) {
    return app(o,
    /* array */
    [a0]);
  } else {
    switch (arity) {
      case 0:
      case 1:
        return o(a0);

      case 2:
        return function (param) {
          return o(a0, param);
        };

      case 3:
        return function (param, param$1) {
          return o(a0, param, param$1);
        };

      case 4:
        return function (param, param$1, param$2) {
          return o(a0, param, param$1, param$2);
        };

      case 5:
        return function (param, param$1, param$2, param$3) {
          return o(a0, param, param$1, param$2, param$3);
        };

      case 6:
        return function (param, param$1, param$2, param$3, param$4) {
          return o(a0, param, param$1, param$2, param$3, param$4);
        };

      case 7:
        return function (param, param$1, param$2, param$3, param$4, param$5) {
          return o(a0, param, param$1, param$2, param$3, param$4, param$5);
        };
    }
  }
}

function _1(o, a0) {
  var arity = o.length;

  if (arity === 1) {
    return o(a0);
  } else {
    return curry_1(o, a0, arity);
  }
}

function __1(o) {
  var arity = o.length;

  if (arity === 1) {
    return o;
  } else {
    return function (a0) {
      return _1(o, a0);
    };
  }
}
/* No side effect */

/* No side effect */

/* No side effect */

/* No side effect */

/* node_std_output Not a pure module */

/* No side effect */


var imul = Math.imul || function (x, y) {
  y |= 0;
  return ((x >> 16) * y << 16) + (x & 0xffff) * y | 0;
};
/* imul Not a pure module */

/* repeat Not a pure module */

/* two_ptr_32_dbl Not a pure module */

/* float_of_string Not a pure module */


function caml_create_string(len) {
  if (len < 0) {
    throw [invalid_argument, "String.create"];
  } else {
    var result = new Array(len);

    for (var i = 0, i_finish = len - 1 | 0; i <= i_finish; ++i) {
      result[i] =
      /* "\000" */
      0;
    }

    return result;
  }
}

function caml_blit_string(s1, i1, s2, i2, len) {
  if (len > 0) {
    var off1 = s1.length - i1 | 0;

    if (len <= off1) {
      for (var i = 0, i_finish = len - 1 | 0; i <= i_finish; ++i) {
        s2[i2 + i | 0] = s1.charCodeAt(i1 + i | 0);
      }

      return (
        /* () */
        0
      );
    } else {
      for (var i$1 = 0, i_finish$1 = off1 - 1 | 0; i$1 <= i_finish$1; ++i$1) {
        s2[i2 + i$1 | 0] = s1.charCodeAt(i1 + i$1 | 0);
      }

      for (var i$2 = off1, i_finish$2 = len - 1 | 0; i$2 <= i_finish$2; ++i$2) {
        s2[i2 + i$2 | 0] =
        /* "\000" */
        0;
      }

      return (
        /* () */
        0
      );
    }
  } else {
    return 0;
  }
}

function caml_blit_bytes(s1, i1, s2, i2, len) {
  if (len > 0) {
    if (s1 === s2) {
      var s1$1 = s1;
      var i1$1 = i1;
      var i2$1 = i2;
      var len$1 = len;

      if (i1$1 < i2$1) {
        var range_a = (s1$1.length - i2$1 | 0) - 1 | 0;
        var range_b = len$1 - 1 | 0;
        var range = range_a > range_b ? range_b : range_a;

        for (var j = range; j >= 0; --j) {
          s1$1[i2$1 + j | 0] = s1$1[i1$1 + j | 0];
        }

        return (
          /* () */
          0
        );
      } else if (i1$1 > i2$1) {
        var range_a$1 = (s1$1.length - i1$1 | 0) - 1 | 0;
        var range_b$1 = len$1 - 1 | 0;
        var range$1 = range_a$1 > range_b$1 ? range_b$1 : range_a$1;

        for (var k = 0; k <= range$1; ++k) {
          s1$1[i2$1 + k | 0] = s1$1[i1$1 + k | 0];
        }

        return (
          /* () */
          0
        );
      } else {
        return 0;
      }
    } else {
      var off1 = s1.length - i1 | 0;

      if (len <= off1) {
        for (var i = 0, i_finish = len - 1 | 0; i <= i_finish; ++i) {
          s2[i2 + i | 0] = s1[i1 + i | 0];
        }

        return (
          /* () */
          0
        );
      } else {
        for (var i$1 = 0, i_finish$1 = off1 - 1 | 0; i$1 <= i_finish$1; ++i$1) {
          s2[i2 + i$1 | 0] = s1[i1 + i$1 | 0];
        }

        for (var i$2 = off1, i_finish$2 = len - 1 | 0; i$2 <= i_finish$2; ++i$2) {
          s2[i2 + i$2 | 0] =
          /* "\000" */
          0;
        }

        return (
          /* () */
          0
        );
      }
    }
  } else {
    return 0;
  }
}

function bytes_of_string(s) {
  var len = s.length;
  var res = new Array(len);

  for (var i = 0, i_finish = len - 1 | 0; i <= i_finish; ++i) {
    res[i] = s.charCodeAt(i);
  }

  return res;
}

function bytes_to_string(a) {
  var bytes = a;
  var i = 0;
  var len = a.length;
  var s = "";
  var s_len = len;

  if (i === 0 && len <= 4096 && len === bytes.length) {
    return String.fromCharCode.apply(null, bytes);
  } else {
    var offset = 0;

    while (s_len > 0) {
      var next = s_len < 1024 ? s_len : 1024;
      var tmp_bytes = new Array(next);
      caml_blit_bytes(bytes, offset, tmp_bytes, 0, next);
      s = s + String.fromCharCode.apply(null, tmp_bytes);
      s_len = s_len - next | 0;
      offset = offset + next | 0;
    }

    return s;
  }
}
/* No side effect */


var id =
/* record */
[
/* contents */
0];

function get_id() {
  id[0] += 1;
  return id[0];
}

function create(str) {
  var v_001 = get_id(
  /* () */
  0);
  var v =
  /* tuple */
  [str, v_001];
  v.tag = 248;
  return v;
}
/* No side effect */

/* No side effect */

/* No side effect */


var Exit = create("Pervasives.Exit");
/* No side effect */

function map(f, param) {
  if (param) {
    var r = _1(f, param[0]);

    return (
      /* :: */
      [r, map(f, param[1])]
    );
  } else {
    return (
      /* [] */
      0
    );
  }
}

function iter(f, _param) {
  while (true) {
    var param = _param;

    if (param) {
      _1(f, param[0]);

      _param = param[1];
      continue;
    } else {
      return (
        /* () */
        0
      );
    }
  }
}
/* No side effect */


var $$Error = create("Js_exn.Error");
/* No side effect */

function to_list(a) {
  var _i = a.length - 1 | 0;

  var _res =
  /* [] */
  0;

  while (true) {
    var res = _res;
    var i = _i;

    if (i < 0) {
      return res;
    } else {
      _res =
      /* :: */
      [a[i], res];
      _i = i - 1 | 0;
      continue;
    }
  }
}

var Bottom = create("Array.Bottom");
/* No side effect */

/* No side effect */

var empty = [];

function sub$2(s, ofs, len) {
  if (ofs < 0 || len < 0 || ofs > (s.length - len | 0)) {
    throw [invalid_argument, "String.sub / Bytes.sub"];
  } else {
    var r = caml_create_string(len);
    caml_blit_bytes(s, ofs, r, 0, len);
    return r;
  }
}

function is_space(param) {
  var switcher = param - 9 | 0;

  if (switcher > 4 || switcher < 0) {
    return switcher === 23;
  } else {
    return switcher !== 2;
  }
}

function trim(s) {
  var len = s.length;
  var i = 0;

  while (i < len && is_space(s[i])) {
    i = i + 1 | 0;
  }

  var j = len - 1 | 0;

  while (j >= i && is_space(s[j])) {
    j = j - 1 | 0;
  }

  if (j >= i) {
    return sub$2(s, i, (j - i | 0) + 1 | 0);
  } else {
    return empty;
  }
}
/* No side effect */


function sub$3(s, ofs, len) {
  return bytes_to_string(sub$2(bytes_of_string(s), ofs, len));
}

function concat$3(sep, l) {
  if (l) {
    var hd$$1 = l[0];
    var num =
    /* record */
    [
    /* contents */
    0];
    var len =
    /* record */
    [
    /* contents */
    0];
    iter(function (s) {
      num[0] = num[0] + 1 | 0;
      len[0] = len[0] + s.length | 0;
      return (
        /* () */
        0
      );
    }, l);
    var r = caml_create_string(len[0] + imul(sep.length, num[0] - 1 | 0) | 0);
    caml_blit_string(hd$$1, 0, r, 0, hd$$1.length);
    var pos =
    /* record */
    [
    /* contents */
    hd$$1.length];
    iter(function (s) {
      caml_blit_string(sep, 0, r, pos[0], sep.length);
      pos[0] = pos[0] + sep.length | 0;
      caml_blit_string(s, 0, r, pos[0], s.length);
      pos[0] = pos[0] + s.length | 0;
      return (
        /* () */
        0
      );
    }, l[1]);
    return bytes_to_string(r);
  } else {
    return "";
  }
}

function is_space$1(param) {
  var switcher = param - 9 | 0;

  if (switcher > 4 || switcher < 0) {
    return switcher === 23;
  } else {
    return switcher !== 2;
  }
}

function trim$1(s) {
  if (s === "" || !(is_space$1(s.charCodeAt(0)) || is_space$1(s.charCodeAt(s.length - 1 | 0)))) {
    return s;
  } else {
    return bytes_to_string(trim(bytes_of_string(s)));
  }
}
/* No side effect */
// Generated by BUCKLESCRIPT VERSION 4.0.5, PLEASE EDIT WITH CARE


var header = "apiVersion: v1\nkind: ConfigMap\ndata:\n";

function filenameLine(filename) {
  return "  " + (filename + ": |\n");
}

function filecontentBlock(filecontent) {
  return concat$3("\n", map(function (line) {
    return "    " + line;
  }, to_list(filecontent.split("\n")))) + "\n";
}

function metadata(name, ns) {
  return "metadata:\n  name: " + (String(name) + ("\n  namespace: " + (String(ns) + "\n")));
}

function _transform(name, ns, filename, filecontent) {
  return header + (filenameLine(filename) + (filecontentBlock(filecontent) + metadata(name, ns)));
}

function errMsg(name, ns, filename, filecontent) {
  var missingKey = name !== undefined ? ns !== undefined ? filename !== undefined ? filecontent !== undefined ? "mistery" : "filecontent" : "filename" : "namespace" : "name";
  return "[" + (missingKey + "] is missing");
}

function configMapFromJs(param) {
  return (
    /* record */
    [
    /* name */
    param.name,
    /* namespace */
    param.namespace,
    /* filename */
    param.filename,
    /* filecontent */
    param.filecontent]
  );
}

function transform(param) {
  var filecontent = param[
  /* filecontent */
  3];
  var filename = param[
  /* filename */
  2];
  var namespace = param[
  /* namespace */
  1];
  var name = param[
  /* name */
  0];
  var exit = 0;

  if (name !== undefined && namespace !== undefined && filename !== undefined && filecontent !== undefined) {
    return _transform(name, namespace, filename, filecontent);
  } else {
    exit = 1;
  }

  if (exit === 1) {
    return errMsg(name, namespace, filename, filecontent);
  }
}

function transformByObject(absCM) {
  return transform(configMapFromJs(absCM));
}

var $$default = {
  generate: transformByObject
};
/* No side effect */
// Generated by BUCKLESCRIPT VERSION 4.0.5, PLEASE EDIT WITH CARE

function dropLeft(str, idx) {
  var len = str.length;
  return sub$3(str, idx + 1 | 0, (len - idx | 0) - 1 | 0);
}

function keyValueOf(line) {
  var rawIndex = line.indexOf("=");
  var index = rawIndex !== -1 ? rawIndex : undefined;

  if (index !== undefined) {
    var n = index;
    var left = trim$1(sub$3(line, 0, n));
    var right = trim$1(dropLeft(line, n));
    return (
      /* tuple */
      [left, right]
    );
  }
}
/* No side effect */


var undefinedHeader =
/* array */
[];

function some(x) {
  if (x === undefined) {
    var block =
    /* tuple */
    [undefinedHeader, 0];
    block.tag = 256;
    return block;
  } else if (x !== null && x[0] === undefinedHeader) {
    var nid = x[1] + 1 | 0;
    var block$1 =
    /* tuple */
    [undefinedHeader, nid];
    block$1.tag = 256;
    return block$1;
  } else {
    return x;
  }
}

function valFromOption(x) {
  if (x !== null && x[0] === undefinedHeader) {
    var depth = x[1];

    if (depth === 0) {
      return undefined;
    } else {
      return (
        /* tuple */
        [undefinedHeader, depth - 1 | 0]
      );
    }
  } else {
    return x;
  }
}
/* No side effect */


function flatMapU(opt, f) {
  if (opt !== undefined) {
    return f(valFromOption(opt));
  }
}

function flatMap(opt, f) {
  return flatMapU(opt, __1(f));
}
/* No side effect */
// Generated by BUCKLESCRIPT VERSION 4.0.5, PLEASE EDIT WITH CARE


function indent(text, indenter) {
  return concat$3("\n", map(function (line) {
    return indenter + line;
  }, to_list(text.split("\n"))));
}

function genCM(param) {
  var cm = param[
  /* cm */
  1];

  var yaml = function yaml(param) {
    return "" + (String(param[0]) + (": \"" + (String(param[1]) + "\"")));
  };

  var yamlEnv = indent(concat$3("\n", map(function (line) {
    var maybeStr = flatMap(keyValueOf(line), yaml);

    if (maybeStr !== undefined) {
      return maybeStr;
    } else {
      return "something went wrong";
    }
  }, to_list(cm[
  /* env */
  1].split("\n")))), "  ");
  return "apiVersion: v1\nkind: ConfigMap\ndata:\n" + (String(yamlEnv) + ("\nmetadata:\n  name: " + (String(cm[
  /* name */
  0]) + ("\n  namespace: " + (String(param[
  /* namespace */
  0]) + "")))));
}

function genSecret(param) {
  var secret = param[
  /* secret */
  2];

  var encrypt = function encrypt(param) {
    var encValue = JsBase64.Base64.encode(param[1]);
    return "" + (String(param[0]) + (": " + (String(encValue) + "")));
  };

  var encEnv = indent(concat$3("\n", map(function (line) {
    var maybeStr = flatMap(keyValueOf(line), encrypt);

    if (maybeStr !== undefined) {
      return maybeStr;
    } else {
      return "something went wrong";
    }
  }, to_list(secret[
  /* env */
  1].split("\n")))), "  ");
  return "apiVersion: v1\nkind: Secret\ntype: Opaque\ndata:\n" + (String(encEnv) + ("\nmetadata:\n  name: " + (String(secret[
  /* name */
  0]) + ("\n  namespace: " + (String(param[
  /* namespace */
  0]) + "")))));
}

function genSnippetPiece(key, name, refType) {
  return "\n- name: " + (String(key) + ("\n  valueFrom:\n    " + (String(refType) + (":\n      key: " + (String(key) + ("\n      name: " + (String(name) + "")))))));
}

function genSnippet(param) {
  var extractKey = function extractKey(maybeKV) {
    if (maybeKV !== undefined) {
      return some(maybeKV[0]);
    }
  };

  var snippetsOf = function snippetsOf(param, refType) {
    var name = param[
    /* name */
    0];
    return concat$3("", map(function (line) {
      var maybeKey = extractKey(keyValueOf(line));
      var name$1 = name;
      var refType$1 = refType;

      if (maybeKey !== undefined) {
        return genSnippetPiece(valFromOption(maybeKey), name$1, refType$1);
      } else {
        return "no key found here";
      }
    }, to_list(param[
    /* env */
    1].split("\n"))));
  };

  return trim$1(indent("# Paste this into your deployment" + (snippetsOf(param[
  /* cm */
  1], "configMapKeyRef") + snippetsOf(param[
  /* secret */
  2], "secretKeyRef")), "        "));
}

function gen(input) {
  return (
    /* record */
    [
    /* cm */
    genCM(input),
    /* secret */
    genSecret(input),
    /* envSnippet */
    genSnippet(input)]
  );
}
/* js-base64 Not a pure module */
// Generated by BUCKLESCRIPT VERSION 4.0.5, PLEASE EDIT WITH CARE


function jsEnvMapperInputFromJs(param) {
  return (
    /* record */
    [
    /* namespace */
    param.namespace,
    /* cmName */
    param.cmName,
    /* cmEnv */
    param.cmEnv,
    /* secretName */
    param.secretName,
    /* secretEnv */
    param.secretEnv]
  );
}

function jsEnvMapperOutputToJs(param) {
  return {
    cm: param[
    /* cm */
    0],
    secret: param[
    /* secret */
    1],
    envSnippet: param[
    /* envSnippet */
    2],
    errMsg: param[
    /* errMsg */
    3]
  };
}

function toObject(param) {
  return (
    /* record */
    [
    /* cm */
    param[
    /* cm */
    0],
    /* secret */
    param[
    /* secret */
    1],
    /* envSnippet */
    param[
    /* envSnippet */
    2],
    /* errMsg */
    undefined]
  );
}

function _transform$1(namespace, cmName, cmEnv, secretName, secretEnv) {
  return gen(
  /* record */
  [
  /* namespace */
  namespace,
  /* cm : record */
  [
  /* name */
  cmName,
  /* env */
  cmEnv],
  /* secret : record */
  [
  /* name */
  secretName,
  /* env */
  secretEnv]]);
}

function errMsg$1(namespace, cmName, cmEnv, secretName, secretEnv) {
  var missingKey = namespace !== undefined ? cmName !== undefined ? cmEnv !== undefined ? secretName !== undefined ? secretEnv !== undefined ? "mistery" : "secretEnv" : "secretName" : "cmEnv" : "cmName" : "namespace";
  var errMsg$1 = "[" + (missingKey + "] is missing");
  return (
    /* record */
    [
    /* cm */
    undefined,
    /* secret */
    undefined,
    /* envSnippet */
    undefined,
    /* errMsg */
    errMsg$1]
  );
}

function transform$1(param) {
  var secretEnv = param[
  /* secretEnv */
  4];
  var secretName = param[
  /* secretName */
  3];
  var cmEnv = param[
  /* cmEnv */
  2];
  var cmName = param[
  /* cmName */
  1];
  var namespace = param[
  /* namespace */
  0];
  var tmp;
  var exit = 0;

  if (namespace !== undefined && cmName !== undefined && cmEnv !== undefined && secretName !== undefined && secretEnv !== undefined) {
    tmp = toObject(_transform$1(namespace, cmName, cmEnv, secretName, secretEnv));
  } else {
    exit = 1;
  }

  if (exit === 1) {
    tmp = errMsg$1(namespace, cmName, cmEnv, secretName, secretEnv);
  }

  return jsEnvMapperOutputToJs(tmp);
}

function transformByObject$1(absInput) {
  return transform$1(jsEnvMapperInputFromJs(absInput));
}

var $$default$1 = {
  generate: transformByObject$1
};
/* Generator Not a pure module */
// Generated by BUCKLESCRIPT VERSION 4.0.5, PLEASE EDIT WITH CARE

var fileCM = $$default;
var envMapper = $$default$1;
/* EnvMapper Not a pure module */

exports.fileCM = fileCM;
exports.envMapper = envMapper;